module.exports = __webpack_public_path__ + "static/media/background.6e8c9423.png";